export const CARD_HEADER_BG = 'bg-white'
